import { useState, useEffect } from 'react'
import * as XLSX from 'xlsx';
import { useParams, useHistory } from "react-router-dom";
import { api } from '../../services/api';
import { toast } from "react-toastify";
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from "react-responsive";
import { Container, Badge, Alert, Button, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Paper, CircularProgress, Tab, Tabs, Box } from '@mui/material';
import { InsertDriveFileOutlined, SaveAltOutlined, Check, DeleteOutlineOutlined, } from '@mui/icons-material';
import useEventoStore from '../../stores/useEventoStore';

export const ExcelImport = () => {
  const [typeError, setTypeError] = useState(null);
  const [excelData, setExcelData] = useState(null);
  const param = useParams();
  const history = useHistory();
  const [evento, setEvento] = useState(null);
  const [setCategorias] = useState();
  const [setUbicaciones] = useState();
  const [tarifas, setTarifas] = useState();
  const [state, setState] = useState({
    showResult: false,
    apiMessage: "",
    error: null,
  });
  const [enviado, setEnviado] = useState(false);
  const [t] = useTranslation("global");
  const isMobile = useMediaQuery({ query: `(max-width: 1000px)` });
  const [fileName, setFileName] = useState('');
  const [loading, setLoading] = useState(false);
  const [loadingDownload, setLoadingDownload] = useState(false);

  const isRecepcion = evento?.eventos_tipos_id === 8;

  const notify = (type, message, position = "bottom-center") => {
    const options = {
      position,
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    }
    switch (type) {
      case 'success':
        toast.success(message, options);
        break;
      case 'error':
        toast.error(message, options);
        break;
      case 'info':
        toast.info(message, options);
        break;
      case 'warning':
        toast.warning(message, options);
        break;
      default:
        toast(message, options);
    }
  }

  useEffect(() => {
    const fetchEvento = async () => {
      try {
        const data = await useEventoStore.getState().fetchEvento(param.id);
        if (data) {
          setEvento(data.evento);
        }
      } catch (error) {
        console.error('Error al obtener evento:', error);
        setState(prevState => ({
          ...prevState,
          error: "Error al cargar el evento.",
        }));
      }
    };
    fetchEvento();
  }, [param.id]);

  useEffect(() => {
    const fetchCategorias = async () => {
      if (isRecepcion) return;
      try {
        let totalCategorias = [];
        let currentPage = 1;
        let hasMoreTickets = true;
        let filtro = '';

        while (hasMoreTickets) {
          const response = await api.categorias.getAll(param.id, filtro, 10, currentPage);
          if (response.status === "success") {
            const categorias = response.data.categorias;

            if (categorias && categorias.length > 0) {
              totalCategorias = [...totalCategorias, ...categorias];
              currentPage++;
            } else {
              hasMoreTickets = false;
            }
          }
          setCategorias(totalCategorias)
        }
      } catch (error) {
        setState({
          ...state,
          error: error.error,
        });
      }
    }
    if (evento) fetchCategorias();
    document.title = `Importar Excel | PassGo`;
  }, [param.id, isRecepcion, evento]);


  useEffect(() => {
    const fetchUbicaciones = async () => {
      if (isRecepcion) return;
      try {
        let totalUbicaciones = [];
        let currentPage = 1;
        let hasMoreTickets = true;
        let filtro = '';

        while (hasMoreTickets) {
          const response = await api.locations.getAll(param.id, filtro, 10, currentPage);
          if (response.status === "success") {
            const ubicaciones = response.data.ubicaciones;

            if (ubicaciones && ubicaciones.length > 0) {
              totalUbicaciones = [...totalUbicaciones, ...ubicaciones];
              currentPage++;
            } else {
              hasMoreTickets = false;
            }
          }
          setUbicaciones(totalUbicaciones)
        }
      } catch (error) {
        setState({
          ...state,
          error: error.error,
        })
      }
    }
    if (evento) fetchUbicaciones();
  }, [param.id, isRecepcion, evento])

  useEffect(() => {
    const fetchTarifa = async () => {
      if (isRecepcion) return;
      try {
        let totalTarifas = [];
        let currentPage = 1;
        let hasMoreTickets = true;
        let filtro = '';

        while (hasMoreTickets) {
          const response = await api.tarifas.getAll(param.id, filtro, 10, currentPage);
          if (response.status === "success") {
            const tarifas = response.data.tarifas;

            if (tarifas && tarifas.length > 0) {
              totalTarifas = [...totalTarifas, ...tarifas];
              currentPage++;
            } else {
              hasMoreTickets = false;
            }
          }
          setTarifas(totalTarifas)
        }
      } catch (error) {
        setState({
          ...state,
          error: error.error,
        });
      }
    }
    if (evento) fetchTarifa();
  }, [param.id, isRecepcion, evento]);

  const entradasTarifas = tarifas?.filter((tarifa) => tarifa.idtipo === 1);

  const procesarArchivoExcel = (e) => {
    const archivo = e.target.files[0];
    const filtro = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel']
    if (archivo) {
      if (archivo && filtro.includes(archivo.type)) {
        setTypeError(null);
        setFileName(archivo.name);
        if (isRecepcion) {
          leerArchivoExcelRecepcion(archivo);
        } else {
          leerArchivoExcel(archivo);
        }
      }
      else {
        setTypeError('Por favor, asegúrese de que el archivo seleccionado sea de tipo Excel(.xlsx o .xls.)')
        setFileName('');
      }
    }
  }

  const validaryGuardar = () => {
    setLoading(true);
    if (!excelData) {
      setTypeError('Por favor, cargue un archivo Excel válido antes de enviar.');
      setLoading(false);
      return;
    }

    if (isRecepcion) {
      validaryGuardarRecepcion();
    } else {
      validaryGuardarComun();
    }
  };

  //validacion eventos ocmunes, campo nombre y apellido
  const validaryGuardarComun = () => {
    let errores = [];
    let valido = true;

    excelData.forEach((fila, index) => {
      // las columnas de identidad se buscan por texto ("titular"), no por posicion,
      // ya que el excel puede traer columnas corridas/vacias segun como se haya guardado.
      // "titular" es lo que evita confundirlas con una pregunta de info adicional
      // que se llame simplemente "Nombre" o "Apellido".
      const nombreKey = Object.keys(fila).find(key => {
        const k = key.toLowerCase();
        return k.includes('nombre') && k.includes('titular');
      });
      const apellidoKey = Object.keys(fila).find(key => {
        const k = key.toLowerCase();
        return k.includes('apellido') && k.includes('titular');
      });

      if (!nombreKey || !fila[nombreKey] || fila[nombreKey].trim() === '') {
        errores.push(`Fila ${index + 1}: El nombre del titular es obligatorio`);
        valido = false;
      }

      if (!apellidoKey || !fila[apellidoKey] || fila[apellidoKey].trim() === '') {
        errores.push(`Fila ${index + 1}: El apellido del titular es obligatorio`);
        valido = false;
      }

      const nombreRegex = /^[a-zA-ZÀ-ÿ0-9\s]{1,40}$/;
      if (nombreKey && fila[nombreKey] && !nombreRegex.test(fila[nombreKey].trim())) {
        errores.push(`Fila ${index + 1}: El nombre del titular contiene caracteres no válidos`);
        valido = false;
      }

      if (apellidoKey && fila[apellidoKey] && !nombreRegex.test(fila[apellidoKey].trim())) {
        errores.push(`Fila ${index + 1}: El apellido del titular contiene caracteres no válidos`);
        valido = false;
      }
    });

    if (!valido) {
      setTypeError(`Los datos del archivo Excel contienen errores:\n${errores.join('\n')}`);
      setLoading(false);
      return;
    }
    guardarTickets();
  };

  //validacion recepciones, campos egresado cena y baile
  const validaryGuardarRecepcion = () => {
    let errores = [];
    let valido = true;

    excelData.forEach((fila, index) => {
      const egresado = fila.egresado || '';
      if (!egresado || egresado.trim() === '') {
        errores.push(`Fila ${index + 1}: El nombre del egresado es obligatorio`);
        valido = false;
      }

      const cena = fila.cena;
      if (cena === undefined || cena === null || isNaN(Number(cena))) {
        errores.push(`Fila ${index + 1}: La cantidad de cena debe ser un número válido (puede ser 0 o estar vacío)`);
        valido = false;
      }

      const baile = fila.baile;
      if (baile === undefined || baile === null || isNaN(Number(baile))) {
        errores.push(`Fila ${index + 1}: La cantidad de baile debe ser un número válido (puede ser 0 o estar vacío)`);
        valido = false;
      }

      if (egresado && egresado.trim() !== '') {
        const nombreCompleto = egresado.trim().split(' ');
        if (nombreCompleto.length < 2) {
          errores.push(`Fila ${index + 1}: El egresado debe tener nombre y apellido`);
          valido = false;
        }
      }
    });

    if (!valido) {
      setTypeError(`Los datos del archivo Excel contienen errores:\n${errores.join('\n')}`);
      setLoading(false);
      return;
    }
    guardarTicketsRecepcion();
  };

  const guardarTickets = async () => {
    try {
      setLoading(true);

      //creo el libro del excel
      const wb = XLSX.utils.book_new();

      // agrupo la info por tarifa
      const datosPorTarifa = excelData.reduce((acc, row) => {
        if (!row.nametarifa) return acc;

        const sheetName = cleanSheetName(row.nametarifa);

        if (!acc[sheetName]) {
          acc[sheetName] = [];
        }

        const rowData = {
          'Nombre del titular*': row.nombre || row['Nombre del titular*'] || row['Nombre*'] || row['nombre'],
          'Apellido del titular*': row.apellido || row['Apellido del titular*'] || row['Apellido*'] || row['apellido']
        };

        Object.keys(row).forEach(key => {
          if (key !== 'nombre' && key !== 'apellido') {
            rowData[key] = row[key];
          }
        });

        acc[sheetName].push(rowData);
        return acc;
      }, {});

      if (Object.keys(datosPorTarifa).length === 0) {
        throw new Error('No hay datos válidos para procesar');
      }

      // una hoja por tarifa
      Object.entries(datosPorTarifa).forEach(([sheetName, data]) => {
        const ws = XLSX.utils.json_to_sheet(data);
        XLSX.utils.book_append_sheet(wb, ws, sheetName);
      });

      // convierto a blob
      const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
      const blob = new Blob([excelBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });

      // creo el archivo y lo envío 
      const file = new File([blob], 'tickets.xlsx', {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      const formData = new FormData();
      formData.append('file', file);

      const response = await api.tickets.createExcelTickets(param.id, formData);

      if (response.status === 'success') {
        setEnviado(true);
        cleanFile();
        notify('success', 'Tickets creados exitosamente');
        setTimeout(() => {
          history.push(`/eventos/${param.id}`);
        }, 2000);
      } else {
        notify('error', response.message || 'Error al crear los tickets');
      }
    } catch (error) {
      console.error('Error al intentar guardar los tickets:', error);
      notify('error', error.message || 'Error al intentar guardar los tickets');
    } finally {
      setLoading(false);
    }
  };

  const guardarTicketsRecepcion = async () => {
    try {
      setLoading(true);

      const formData = new FormData();

      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(excelData);
      XLSX.utils.book_append_sheet(wb, ws, 'Recepciones');

      const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
      const blob = new Blob([excelBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });

      const file = new File([blob], 'recepciones.xlsx', {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });

      formData.append('file', file);

      const response = await api.tickets.createExcelRecepciones(param.id, formData);

      if (response.status === 'success') {
        setEnviado(true);
        cleanFile();
        notify('success', response.message || 'Tickets de recepción creados exitosamente');
        setTimeout(() => {
          history.push(`/eventos/${param.id}`);
        }, 2000);
      } else {
        notify('error', response.message || 'Error al crear los tickets de recepción');
      }
    } catch (error) {
      console.error('Error al intentar guardar los tickets de recepción:', error);
      notify('error', error.message || 'Error al intentar guardar los tickets de recepción');
    } finally {
      setLoading(false);
    }
  };

  function cleanSheetName(name) {
    const forbidden = [":", "\\", "/", "?", "*", "[", "]"];
    let cleaned = name;
    forbidden.forEach(c => {
      cleaned = cleaned.replaceAll(c, "");
    });
    const maxLen = 28;
    if (cleaned.length > maxLen) {
      cleaned = cleaned.substring(0, maxLen) + "...";
    }
    return cleaned;
  }

  const leerArchivoExcel = (archivo) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const binaryStr = e.target.result;
        const workbook = XLSX.read(binaryStr, { type: 'binary' });

        let allData = [];
        workbook.SheetNames.forEach(sheetName => {
          // buscar la tarifa que coincida con el nombre de la hoja limpia
          const tarifa = entradasTarifas?.find(t => cleanSheetName(t.concepto) === sheetName);
          if (!tarifa) return; // si no hay tarifa, ignora la hoja

          const sheet = workbook.Sheets[sheetName];
          const jsonData = XLSX.utils.sheet_to_json(sheet);

          if (jsonData && jsonData.length > 0) {
            const sheetData = jsonData.map(row => ({
              ...row,
              nametarifa: tarifa.concepto // Guarda el nombre original de la tarifa
            }));
            allData = [...allData, ...sheetData];
          }
        });

        if (!allData || allData.length === 0) {
          setTypeError('El archivo Excel está vacío o no tiene el formato correcto');
          setFileName('');
          return;
        }

        const cleanedJson = allData.map(row => {
          const cleanedRow = {};
          for (const key in row) {
            // Convertir a minúsculas y eliminar espacios
            const normalizedKey = key.toLowerCase().trim();
            let value = String(row[key]).replace(/\t/g, '').trim();

            // Manejar tipos específicos
            switch (normalizedKey) {
              case 'nombre':
              case 'apellido':
              case 'nametarifa':
                cleanedRow[normalizedKey] = value;
                break;
              case 'idevento':
                cleanedRow[normalizedKey] = parseInt(value, 10);
                break;
              case 'cantidadtarifa':
                cleanedRow[normalizedKey] = Number(value);
                break;
              case 'importe':
                cleanedRow[normalizedKey] = parseFloat(value);
                break;
              default:
                cleanedRow[normalizedKey] = value;
            }
          }
          return cleanedRow;
        });

        setExcelData(cleanedJson);
      } catch (error) {
        console.error('Error al procesar el Excel:', error);
        setTypeError('Error al procesar el archivo Excel: ' + error.message);
        setFileName('');
      }
    };

    reader.onerror = (error) => {
      console.error('Error al leer el archivo:', error);
      setTypeError('Error al leer el archivo Excel');
      setFileName('');
    };

    reader.readAsBinaryString(archivo);
  };

  const leerArchivoExcelRecepcion = (archivo) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const binaryStr = e.target.result;
        const workbook = XLSX.read(binaryStr, { type: 'binary' });

        const firstSheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[firstSheetName];
        const jsonData = XLSX.utils.sheet_to_json(sheet);

        if (!jsonData || jsonData.length === 0) {
          setTypeError('El archivo Excel está vacío o no tiene el formato correcto');
          setFileName('');
          return;
        }

        const cleanedData = jsonData.map(row => {
          const cleanedRow = {};

          Object.keys(row).forEach(key => {
            const normalizedKey = key.toLowerCase().trim();
            let value = '';
            if (row[key] !== undefined && row[key] !== null) {
              value = String(row[key]).trim();
            }

            switch (normalizedKey) {
              case 'egresado':
                cleanedRow.egresado = value;
                break;
              case 'cena':
                if (value === '' || value === 'undefined' || value === 'null') {
                  cleanedRow.cena = 0;
                } else {
                  cleanedRow.cena = parseInt(value) || 0;
                }
                break;
              case 'baile':
                if (value === '' || value === 'undefined' || value === 'null') {
                  cleanedRow.baile = 0;
                } else {
                  cleanedRow.baile = parseInt(value) || 0;
                }
                break;
              default:
                cleanedRow[normalizedKey] = value;
            }
          });

          if (!cleanedRow.hasOwnProperty('egresado')) {
            cleanedRow.egresado = '';
          }
          if (!cleanedRow.hasOwnProperty('cena')) {
            cleanedRow.cena = 0;
          }
          if (!cleanedRow.hasOwnProperty('baile')) {
            cleanedRow.baile = 0;
          }

          return cleanedRow;
        });

        setExcelData(cleanedData);
      } catch (error) {
        console.error('Error al procesar el Excel de recepción:', error);
        setTypeError('Error al procesar el archivo Excel: ' + error.message);
        setFileName('');
      }
    };

    reader.onerror = (error) => {
      console.error('Error al leer el archivo:', error);
      setTypeError('Error al leer el archivo Excel');
      setFileName('');
    };

    reader.readAsBinaryString(archivo);
  };

  const cleanFile = () => {
    setFileName('');
    setTypeError(null);
    setExcelData(null);
  };

  //descargar la plantilla del excel
  const handleDownloadExcel = async () => {
    setLoadingDownload(true);
    try {
      let response;
      let filename;

      if (isRecepcion) {
        response = await api.tickets.getExcelRecepciones(param.id);
        filename = `recepciones_${param.id}.xlsx`;
      } else {
        response = await api.tickets.getExcelTickets(param.id);
        filename = `tickets_${param.id}.xlsx`;
      }

      const blob = new Blob([response], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error al descargar el archivo Excel:', error);
      notify('error', 'Error al descargar la plantilla');
    } finally {
      setLoadingDownload(false);
    }
  };


  const [activeTab, setActiveTab] = useState(0);

  const getExampleData = () => {
    if (isRecepcion) {
      return {
        tarifas: ["Recepciones"],
        columns: [
          { label: "EGRESADO", key: "egresado" },
          { label: "CENA", key: "cena" },
          { label: "BAILE", key: "baile" }
        ],
        rows: [
          { egresado: "Juan Perez", cena: "5", baile: "10" },
          { egresado: "Maria Gomez", cena: "3", baile: "8" }
        ]
      };
    } else {
      return {
        tarifas: ["General", "VIP", "Campo"],
        columns: [
          { label: "nombre", key: "nombre" },
          { label: "apellido", key: "apellido" },
          ...(activeTab === 1 ? [{ label: "DNI", key: "dni" }] : [])
        ],
        rows: activeTab === 1
          ? [
            { nombre: "Pedro", apellido: "Dominguez", dni: "12345678" },
            { nombre: "Sandra", apellido: "Sanchez", dni: "87654321" }
          ]
          : [
            { nombre: "Juan", apellido: "Perez" },
            { nombre: "Maria", apellido: "Gomez" }
          ]
      };
    }
  };

  const exampleData = getExampleData();
  const getInstructions = () => {
    if (isRecepcion) {
      return {
        title: "Cargar tickets para recepción",
        subtitle: "Sigue los pasos para importar egresados y sus acompañantes.",
        steps: [
          {
            number: 1,
            title: "Descarga la plantilla de Excel",
            description: "La plantilla contiene las columnas: EGRESADO, CENA y BAILE. Cada fila representa un egresado con la cantidad de tickets de cena y baile que necesita."
          },
          {
            number: 2,
            title: "Completa los datos de los egresados",
            description: "IMPORTANTE: Ingresa las cantidades TOTALES que necesita cada egresado. El sistema creará automáticamente solo los tickets faltantes. Por ejemplo: si Juan ya tiene 3 tickets de cena y cargas 5, se crearán solo 2 nuevos."
          }
        ]
      };
    } else {
      return {
        title: "Cargar tickets masivamente",
        subtitle: "Sigue los pasos para importar tus asistentes desde un archivo Excel.",
        steps: [
          {
            number: 1,
            title: "Descarga la plantilla de Excel",
            description: "La plantilla contiene una hoja por cada tarifa de tu evento. Por ejemplo, si tienes las tarifas \"Mesa VIP\", \"Mesa General\" y \"Campo\", el archivo Excel tendrá tres hojas con esos nombres."
          },
          {
            number: 2,
            title: "Completa los datos de los asistentes",
            description: "En cada hoja, ingresa el nombre y apellido de cada asistente que haya comprado esa tarifa específica. No modifiques el nombre de las hojas ni el orden de las columnas. En caso de que una tarifa cuente con información adicional, cada hoja incluye columnas extra para esos datos."
          }
        ]
      };
    }
  };

  const instructions = getInstructions();

  if (!evento) {
    return (
      <Container maxWidth="lg" sx={{ mt: 4, display: 'flex', justifyContent: 'center' }}>
        <CircularProgress />
      </Container>
    );
  }

  return (
    <>
      <Container maxWidth="lg" sx={{ mt: 4, p: "0 !important" }}>
        {isMobile ? (
          <div style={{
            padding: "12px",
            paddingTop: "0",
            display: 'flex',
            flexDirection: 'column',
            gap: '24px',
            alignItems: 'stretch'
          }}>
            {/* INSTRUCCIONES */}
            <div style={{ width: "100%" }}>
              <div style={{
                display: 'flex',
                flexDirection: "column",
                justifyContent: 'space-between',
                marginBottom: 8
              }}>
                <div>
                  <h1 style={{ fontWeight: 700, fontSize: 24, margin: 0 }}>{instructions.title}</h1>
                  <p style={{ color: "#6C757D", margin: 0, fontSize: 16 }}>
                    {instructions.subtitle}
                  </p>
                </div>
                <Button
                  variant="contained"
                  color="success"
                  onClick={handleDownloadExcel}
                  startIcon={loadingDownload ? <CircularProgress size={20} color="inherit" /> : <SaveAltOutlined />}
                  disabled={loadingDownload}
                  sx={{ fontWeight: 600, fontSize: 15, borderRadius: 2, px: 2, py: 1 }}
                >
                  {loadingDownload ? 'Descargando...' : 'Descargar plantilla'}
                </Button>
              </div>
              <Box sx={{ background: "#F8F9FB", borderRadius: 2, p: 3, mb: 3 }}>
                <div style={{ display: 'flex', gap: 16 }}>
                  <div style={{ flex: 1 }}>
                    {instructions.steps.map((step) => (
                      <div key={step.number} style={{ display: 'flex', alignItems: 'flex-start', gap: 12, marginBottom: 18 }}>
                        <Badge
                          sx={{
                            background: "#5656FF",
                            color: "#fff",
                            borderRadius: "50%",
                            width: 28,
                            height: 28,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontWeight: 700,
                            fontSize: 16,
                            mr: 1
                          }}
                        >{step.number}</Badge>
                        <div>
                          <strong>{step.title}</strong>
                          <div style={{ fontSize: 15, color: "#6C757D" }}>
                            {step.description}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </Box>
            </div>
            {/* CARGA DE ARCHIVO */}
            <div style={{
              width: "100%",
              background: '#fff',
              borderRadius: '12px',
              boxShadow: '0 2px 12px rgba(0,0,0,0.05)',
              padding: '32px',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center'
            }}>
              <h3 style={{ fontWeight: 600, marginBottom: 16 }}>Subir archivo</h3>
              {!fileName ? (
                <label
                  htmlFor="excelFile"
                  style={{
                    border: '2px dashed #E1E2E6',
                    borderRadius: 10,
                    padding: 24,
                    width: '100%',
                    textAlign: 'center',
                    marginBottom: 16,
                    background: '#F8F9FB',
                    cursor: loading || enviado ? "not-allowed" : "pointer",
                    opacity: loading || enviado ? 0.5 : 1,
                    pointerEvents: loading || enviado ? "none" : "auto",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    position: "relative"
                  }}
                >
                  <InsertDriveFileOutlined sx={{ color: "#5656FF", fontSize: 40 }} />
                  <span style={{ color: "#5656FF", fontWeight: 500, marginTop: 4 }}>Seleccionar archivo</span>
                  <input
                    id="excelFile"
                    name="file"
                    type="file"
                    accept=".xlsx,.xls"
                    hidden
                    onChange={procesarArchivoExcel}
                    disabled={loading || enviado}
                  />
                </label>
              ) : (
                <div style={{
                  border: '2px dashed #E1E2E6',
                  borderRadius: 10,
                  padding: 24,
                  width: '100%',
                  textAlign: 'center',
                  marginBottom: 16,
                  background: '#F8F9FB',
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  position: "relative"
                }}>
                  <InsertDriveFileOutlined sx={{ color: "#5656FF", fontSize: 40 }} />
                  <span style={{ fontWeight: 500, color: "#5656FF", marginLeft: 8 }}>{fileName}</span>
                  {loading && <CircularProgress size={18} sx={{ ml: 1 }} />}
                  <DeleteOutlineOutlined
                    sx={{
                      position: "absolute",
                      right: 16,
                      top: "50%",
                      transform: "translateY(-50%)",
                      color: "#dc2626",
                      fontSize: 22,
                      cursor: "pointer",
                      background: "#fff",
                      borderRadius: "50%",
                      boxShadow: "0 1px 4px rgba(0,0,0,0.08)"
                    }}
                    onClick={cleanFile}
                  />
                </div>
              )}
              <div style={{ display: 'flex', gap: 12, width: '100%' }}>
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={validaryGuardar}
                  disabled={loading || enviado || !fileName}
                  startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}
                >
                  {loading ? 'Enviando...' : 'Crear tickets'}
                </Button>
              </div>
              {typeError &&
                <Alert severity="error" sx={{ mt: 2, width: '100%' }}>{typeError}</Alert>
              }
              {enviado && (
                <Alert icon={<Check fontSize="inherit" />} severity="success" sx={{ mt: 2, width: '100%' }}>
                  Importación exitosa.
                </Alert>
              )}
            </div>
            {/* EJEMPLO */}
            <div style={{ width: "100%" }}>
              <h3 style={{ fontWeight: 600, marginBottom: 12 }}>Ejemplo visual del archivo Excel</h3>
              {!isRecepcion && (
                <Tabs
                  value={activeTab}
                  onChange={(_, newValue) => setActiveTab(newValue)}
                  textColor="primary"
                  indicatorColor="primary"
                  sx={{ mb: 2 }}
                >
                  {exampleData.tarifas.map((tarifa, idx) => (
                    <Tab
                      key={tarifa}
                      label={tarifa}
                      sx={{
                        fontWeight: 500,
                        fontSize: 15,
                        textTransform: "none",
                        minWidth: 120
                      }}
                    />
                  ))}
                </Tabs>
              )}
              <Paper elevation={0} sx={{ background: "#F8F9FB", borderRadius: 2 }}>
                <TableContainer>
                  <Table>
                    <TableHead>
                      <TableRow>
                        {exampleData.columns.map(col => (
                          <TableCell key={col.key}><strong>{col.label}</strong></TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {exampleData.rows.map((row, idx) => (
                        <TableRow key={idx}>
                          {exampleData.columns.map(col => (
                            <TableCell key={col.key}>{row[col.key]}</TableCell>
                          ))}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Paper>
              <div style={{ marginTop: 12, color: "#6C757D", fontSize: 14 }}>
                {isRecepcion
                  ? "Completa los datos de cada egresado con las cantidades para cena y baile."
                  : "Completa los datos en cada hoja según la tarifa. Si hay preguntas adicionales, aparecerán como columnas extra."
                }
              </div>
            </div>
          </div>
        ) : (
          <div style={{
            display: 'flex',
            gap: '24px',
            justifyContent: 'space-between',
            alignItems: 'flex-start'
          }}>
            {/* INSTRUCCIONES */}
            <div style={{ flex: 1, minWidth: 380 }}>
              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: 8
              }}>
                <div>
                  <h1 style={{ fontWeight: 700, fontSize: 24, margin: 0 }}>{instructions.title}</h1>
                  <p style={{ color: "#6C757D", margin: 0, fontSize: 16 }}>
                    {instructions.subtitle}
                  </p>
                </div>
                <Button
                  variant="contained"
                  color="success"
                  onClick={handleDownloadExcel}
                  startIcon={loadingDownload ? <CircularProgress size={20} color="inherit" /> : <SaveAltOutlined />}
                  disabled={loadingDownload}
                  sx={{ fontWeight: 600, fontSize: 15, borderRadius: 2, px: 2, py: 1 }}
                >
                  {loadingDownload ? 'Descargando...' : 'Descargar plantilla'}
                </Button>
              </div>
              <Box sx={{ background: "#F8F9FB", borderRadius: 2, p: 3, mb: 3 }}>
                <div style={{ display: 'flex', gap: 16 }}>
                  <div style={{ flex: 1 }}>
                    {instructions.steps.map((step) => (
                      <div key={step.number} style={{ display: 'flex', alignItems: 'flex-start', gap: 12, marginBottom: 18 }}>
                        <Badge
                          sx={{
                            background: "#5656FF",
                            color: "#fff",
                            borderRadius: "50%",
                            width: 28,
                            height: 28,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontWeight: 700,
                            fontSize: 16,
                            mr: 1
                          }}
                        >
                          {step.number}
                        </Badge>
                        <div>
                          <strong>{step.title}</strong>
                          <div style={{ fontSize: 15, color: "#6C757D" }}>
                            {step.description}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </Box>
              {/* EJEMPLO */}
              <div>
                <h3 style={{ fontWeight: 600, marginBottom: 12 }}>Ejemplo visual del archivo Excel</h3>
                {!isRecepcion && (
                  <Tabs
                    value={activeTab}
                    onChange={(_, newValue) => setActiveTab(newValue)}
                    textColor="primary"
                    indicatorColor="primary"
                    sx={{ mb: 2 }}
                  >
                    {exampleData.tarifas.map((tarifa, idx) => (
                      <Tab
                        key={tarifa}
                        label={tarifa}
                        sx={{
                          fontWeight: 500,
                          fontSize: 15,
                          textTransform: "none",
                          minWidth: 120
                        }}
                      />
                    ))}
                  </Tabs>
                )}

                <Paper elevation={0} sx={{ background: "#F8F9FB", borderRadius: 2 }}>
                  <TableContainer>
                    <Table>
                      <TableHead>
                        <TableRow>
                          {exampleData.columns.map(col => (
                            <TableCell key={col.key}>
                              <strong>{col.label}</strong>
                            </TableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {exampleData.rows.map((row, idx) => (
                          <TableRow key={idx}>
                            {exampleData.columns.map(col => (
                              <TableCell key={col.key}>{row[col.key]}</TableCell>
                            ))}
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Paper>

                <div style={{ marginTop: 12, color: "#6C757D", fontSize: 14 }}>
                  {isRecepcion
                    ? "Completa los datos de cada egresado con las cantidades para cena y baile."
                    : "Completa los datos en cada hoja según la tarifa. Si hay preguntas adicionales, aparecerán como columnas extra."
                  }
                </div>
              </div>
            </div>
            {/* CARGA DE ARCHIVO */}
            <div style={{
              flex: '0 0 320px',
              background: '#fff',
              borderRadius: '12px',
              boxShadow: '0 2px 12px rgba(0,0,0,0.05)',
              padding: '32px',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center'
            }}>
              <h3 style={{ fontWeight: 600, marginBottom: 16 }}>Subir archivo</h3>
              {!fileName ? (
                <label
                  htmlFor="excelFile"
                  style={{
                    border: '2px dashed #E1E2E6',
                    borderRadius: 10,
                    padding: 24,
                    width: '100%',
                    textAlign: 'center',
                    marginBottom: 16,
                    background: '#F8F9FB',
                    cursor: loading || enviado ? "not-allowed" : "pointer",
                    opacity: loading || enviado ? 0.5 : 1,
                    pointerEvents: loading || enviado ? "none" : "auto",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    position: "relative"
                  }}
                >
                  <InsertDriveFileOutlined sx={{ color: "#5656FF", fontSize: 40 }} />
                  <span style={{ color: "#5656FF", fontWeight: 500, marginTop: 4 }}>Seleccionar archivo</span>
                  <input
                    id="excelFile"
                    name="file"
                    type="file"
                    accept=".xlsx,.xls"
                    hidden
                    onChange={procesarArchivoExcel}
                    disabled={loading || enviado}
                  />
                </label>
              ) : (
                <div style={{
                  border: '2px dashed #E1E2E6',
                  borderRadius: 10,
                  padding: 24,
                  width: '100%',
                  textAlign: 'center',
                  marginBottom: 16,
                  background: '#F8F9FB',
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  position: "relative"
                }}>
                  <InsertDriveFileOutlined sx={{ color: "#5656FF", fontSize: 40 }} />
                  <span style={{ fontWeight: 500, color: "#5656FF", marginLeft: 8 }}>{fileName}</span>
                  {loading && <CircularProgress size={18} sx={{ ml: 1 }} />}
                  <DeleteOutlineOutlined
                    sx={{
                      position: "absolute",
                      right: 16,
                      top: "50%",
                      transform: "translateY(-50%)",
                      color: "#dc2626",
                      fontSize: 22,
                      cursor: "pointer",
                      background: "#fff",
                      borderRadius: "50%",
                      boxShadow: "0 1px 4px rgba(0,0,0,0.08)"
                    }}
                    onClick={cleanFile}
                  />
                </div>
              )}
              <div style={{ display: 'flex', gap: 12, width: '100%' }}>
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={validaryGuardar}
                  disabled={loading || enviado || !fileName}
                  startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}
                >
                  {loading ? 'Enviando...' : 'Crear tickets'}
                </Button>
              </div>
              {typeError &&
                <Alert severity="error" sx={{ mt: 2, width: '100%' }}>{typeError}</Alert>
              }
              {enviado && (
                <Alert icon={<Check fontSize="inherit" />} severity="success" sx={{ mt: 2, width: '100%' }}>
                  Importación exitosa.
                </Alert>
              )}
            </div>
          </div>
        )}
      </Container >
    </>
  )
}
